/**
 * MI-329 — the rates a converted ("≈") figure read, as the API names them:
 * 'trm' (Colombia's official TRM), 'market' (exchangerate-api.com) and
 * 'movement' (the rate a movement captured itself). A figure that read several
 * names them all: PEN→COP takes PEN from the market and COP from the TRM.
 */
const ORDER = ['trm', 'market', 'movement'];

/** Every list's sources, once each, in the order the tooltip names them. */
export function mergeRateSources(...lists) {
  const all = new Set(lists.flat().filter(Boolean));
  return ORDER.filter((code) => all.has(code));
}

/**
 * Whether a figure shown in `target` converted anything: some of its amounts
 * were in another currency. One that did not is exact and is not marked "≈",
 * the rule the movement list and the phone's accounts already follow.
 */
export function holdsForeign(currencies, target) {
  return (currencies || []).some((c) => c && c !== target);
}

/**
 * The sources behind balances converted at today's rate: those of each
 * currency that is not already `target`, and of `target` itself. `sourceOf`
 * maps a currency to the `rate_source` GET /currencies gives it (none for USD,
 * which needs no rate).
 */
export function balanceRateSources(currencies, target, sourceOf) {
  if (!holdsForeign(currencies, target)) return [];
  const converted = currencies.filter((c) => c && c !== target);
  return mergeRateSources(converted.map((c) => sourceOf?.[c]), [sourceOf?.[target]]);
}
